export class ConsequenceAnnulation {
  id: number;
  consequence: string;
  constructor(id: number, consequence: string) {
    this.id = id;
    this.consequence = consequence;
  }
}
